<template>
  <v-text-field
    ref="form"
    class="ml-4"
    append-icon="search"
    :label="title"
    v-model="search"
    clearable
    hide-details
    onkeypress="if(this.value.length==16) return false;"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Search"
    }
  },
  data() {
    return {
      timeOut: null
    };
  },
  computed: {
    search: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.$emit("search", value);
        }, 500);
      }
    }
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
